
<div class="col-md-12 main-heading">
  <div class="d-flex">
    <a routerLink="/index">
      <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
    </a>
    <div class="caption-heading">Occupancy</div>
  </div>
</div>
<div class="col-md-12 pagecustom">
  <div class="page-wrapper">
    <div class="row main-container boxscroll">
      <div class="block-section full-table">
        <div class="heading-m">
          <div class="caption">
            Occupancy
          </div>
        </div>
        <div class="list-sidebar">
          <table style="width:600px; text-align:center;">
            <tbody>
              <tr>
                <td>
                  <canvas id="chartTotalParkingCapacity" style="max-width:600px"></canvas>
                </td>
              </tr>
              <tr>
                <td>
                  <br />
                  <br />
                  Total Capacity : <span id="totalCapacitySpan">0</span>
                </td>
              </tr>
              <tr>
                <td>
                  Available : <span id="availableCapacitySpan">0</span>
                </td>
              </tr>
              <tr>
                <td>
                  Occupied : <span id="occupiedCapacitySpan">0</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
